// extracted by mini-css-extract-plugin
export default {"button_common":"Base_button_common__UqjAb","error":"Base_error__Yo2TX","button_modal":"Base_button_modal__RY-8M"};